function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CaymanIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    clipPath: "url(#b)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#2E42A5",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsxs("g", {
      clipPath: "url(#c)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#fff",
        stroke: "#F7FCFF",
        strokeWidth: ".25",
        d: "M16.386 12.641h-.125v1.801c0 1.105.463 1.843.936 2.303.235.229.473.389.656.491a2.366 2.366 0 0 0 .305.143l.028.01h.001a.167.167 0 0 0 .042.005c.02 0 .038-.004.044-.006a1.03 1.03 0 0 0 .1-.039c.057-.025.131-.063.217-.114.172-.104.394-.264.613-.494.44-.46.867-1.197.867-2.299v-1.801h-3.684Z"
      }), /*#__PURE__*/_jsx("mask", {
        id: "d",
        width: "5",
        height: "6",
        x: "16",
        y: "12",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          stroke: "#fff",
          strokeWidth: ".25",
          d: "M16.386 12.641h-.125v1.801c0 1.105.463 1.843.936 2.303.235.229.473.389.656.491a2.366 2.366 0 0 0 .305.143l.028.01h.001a.167.167 0 0 0 .042.005c.02 0 .038-.004.044-.006a1.03 1.03 0 0 0 .1-.039c.057-.025.131-.063.217-.114.172-.104.394-.264.613-.494.44-.46.867-1.197.867-2.299v-1.801h-3.684Z"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#d)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "M16.158 12.485h4.053v1.914h-4.053z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#F50100",
          d: "M17.965 14.793c.13 0 .389-.177.453-.217.238-.177.411-.014.552.067.151.082.432.177.605 0 .173-.176.27-.163.389-.163.022-.203.022-.407.022-.638v-.162c-.152-.041-.227.013-.39.19-.162.176-.345.135-.583.027-.227-.122-.454-.34-.681 0-.065.095-.216.23-.367.23-.163 0-.303-.135-.368-.23-.238-.34-.454-.122-.68 0-.239.108-.433.15-.595-.027-.152-.177-.227-.231-.39-.19v.162c0 .231.011.435.033.638.119 0 .205-.013.378.163.173.177.465.082.606 0 .15-.081.324-.244.562-.068.064.041.313.218.454.218Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD100",
          fillRule: "evenodd",
          d: "M16.871 13.357s.098.005.213.155c.116.149.542.054.542-.036s-.259-.144-.16-.298c.1-.154.268-.154.403-.074.039 0 .035.527.123.498.28-.092.732-.273.864-.196.174.103.308.077.264-.07-.045-.146-.159-.238-.378-.158-.22.08-.168.158-.357.158-.19 0-.515.129-.37-.158.13-.257.283-.262.342-.154.03.055-.215.177-.215.234 0 .079.633-.154.714-.154.081 0 .305-.006.327.074.022.08.157.154.054.228-.103.075-.272.122-.156.218.117.096.413.14.426.239.012.1.14.248.089.248-.051 0-.144.14-.23.098-.085-.043-.096-.08-.013-.115.082-.035.081-.18.013-.18-.067 0-.062-.011-.216-.062-.155-.051-.36-.108-.347 0 .012.107.117.339-.069.36-.186.023-.273.111-.309.04-.036-.071-.165-.166-.064-.197.102-.03.2.104.236.082.036-.022.115-.1.046-.193-.07-.092-.205-.095-.099-.165.107-.069.043-.122-.159.022-.202.143-.315.266-.493.248-.177-.017-.257.062-.314.039-.057-.024-.335.257-.415.186-.08-.071-.339-.099-.292-.186.046-.088.109-.133.178-.088.07.045.139.09.186.045.047-.045.196-.255.162-.286-.035-.031-.155-.084-.348-.084-.193 0-.197-.16-.243-.233-.046-.074.065-.085.065-.085Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#0B50A0",
          d: "M17.965 16.144c.13 0 .389-.177.453-.217.238-.177.411-.014.552.067.151.082.432.177.605 0 .173-.176.27-.163.389-.163.022-.203.022-.407.022-.637v-.163c-.152-.041-.227.013-.39.19-.162.176-.345.135-.583.027-.227-.122-.454-.34-.681 0-.065.095-.216.23-.367.23-.163 0-.303-.135-.368-.23-.238-.34-.454-.122-.68 0-.239.108-.433.15-.595-.027-.152-.177-.227-.231-.39-.19v.162c0 .231.011.435.033.638.119 0 .205-.013.378.163.173.177.465.082.606 0 .15-.081.324-.244.562-.067.064.04.313.217.454.217ZM17.965 17.438c.13 0 .389-.176.453-.217.238-.176.411-.013.552.068.151.081.432.176.605 0s.27-.163.389-.163c.022-.203.022-.407.022-.638v-.163c-.152-.04-.227.014-.39.19-.162.177-.345.136-.583.027-.227-.122-.454-.339-.681 0-.065.095-.216.231-.367.231-.163 0-.303-.136-.368-.23-.238-.34-.454-.123-.68 0-.239.108-.433.149-.595-.028-.152-.176-.227-.23-.39-.19v.163c0 .231.011.434.033.638.119 0 .205-.013.378.163.173.176.465.081.606 0 .15-.081.324-.244.562-.068.064.04.313.217.454.217Z"
        }), /*#__PURE__*/_jsx("mask", {
          id: "e",
          fill: "#fff",
          children: /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            d: "m18 16.559-.287.17.082-.345-.274-.254h.358l.12-.326.14.326h.306l-.24.254.115.344-.32-.17Z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("path", {
          fill: "#059334",
          fillRule: "evenodd",
          d: "m18 16.559-.287.17.082-.345-.274-.254h.358l.12-.326.14.326h.306l-.24.254.115.344-.32-.17Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD100",
          d: "m18 16.559.256-.487-.272-.144-.265.157.28.474Zm-.287.17-.535-.128-.299 1.26 1.115-.66-.28-.473Zm.082-.345.535.126.074-.312-.236-.219-.373.405Zm-.274-.254v-.55h-1.406l1.033.954.373-.404Zm.358 0v.55h.383l.133-.36-.516-.19Zm.12-.326.505-.218-.546-1.264-.475 1.292.516.19Zm.14.326-.504.218.143.332h.362v-.55Zm.306 0 .4.378.878-.928h-1.278v.55Zm-.24.254-.4-.379-.226.24.104.313.522-.174Zm.115.344-.256.486 1.214.642-.436-1.302-.522.174Zm-.601-.643-.286.17.56.946.287-.17-.561-.946Zm.53.77.081-.345-1.07-.253-.082.344 1.07.254Zm-.08-.876-.275-.253-.746.808.274.254.746-.809Zm-.648.701h.358v-1.1h-.358v1.1Zm.874-.36.12-.326-1.032-.38-.12.326 1.032.38Zm-.901-.298.14.326 1.01-.436-.14-.326-1.01.436Zm.646.658h.305v-1.1h-.305v1.1Zm-.095-.928-.24.253.8.757.24-.254-.8-.756Zm-.362.806.116.345 1.043-.35-.115-.344-1.044.349Zm.894-.316-.32-.17-.515.973.322.17.513-.973Z",
          mask: "url(#e)"
        }), /*#__PURE__*/_jsx("mask", {
          id: "f",
          fill: "#fff",
          children: /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            d: "m17.2 15.559-.287.17.082-.345-.274-.254h.358l.12-.326.14.326h.306l-.24.253.115.345-.32-.17Z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("path", {
          fill: "#059334",
          fillRule: "evenodd",
          d: "m17.2 15.559-.287.17.082-.345-.274-.254h.358l.12-.326.14.326h.306l-.24.253.115.345-.32-.17Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD100",
          d: "m17.2 15.559.256-.487-.272-.144-.265.157.28.474Zm-.287.17-.535-.128-.299 1.26 1.115-.66-.28-.473Zm.082-.345.535.126.074-.312-.236-.219-.373.405Zm-.274-.254v-.55h-1.406l1.033.954.373-.404Zm.358 0v.55h.383l.133-.36-.516-.19Zm.12-.326.505-.218-.546-1.264-.475 1.292.516.19Zm.14.326-.504.218.143.332h.362v-.55Zm.306 0 .4.378.878-.928h-1.278v.55Zm-.24.253-.4-.378-.226.24.105.313.521-.175Zm.115.345-.256.487 1.214.64-.436-1.301-.522.174Zm-.601-.643-.286.17.56.946.287-.17-.561-.946Zm.53.77.081-.345-1.07-.253-.082.344 1.07.254Zm-.08-.876-.275-.253-.746.808.274.253.746-.808Zm-.648.701h.358v-1.1h-.358v1.1Zm.874-.36.12-.326-1.032-.38-.12.326 1.032.38Zm-.901-.298.14.326 1.01-.436-.14-.326-1.01.436Zm.646.658h.305v-1.1h-.305v1.1Zm-.094-.928-.24.253.799.757.24-.254-.8-.756Zm-.362.806.115.345 1.043-.35-.115-.344-1.043.349Zm.893-.316-.32-.17-.514.973.32.17.514-.973Z",
          mask: "url(#f)"
        }), /*#__PURE__*/_jsx("mask", {
          id: "g",
          fill: "#fff",
          children: /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            d: "m18.8 15.559-.287.17.082-.345-.274-.254h.358l.12-.326.14.326h.306l-.24.253.115.345-.32-.17Z",
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("path", {
          fill: "#059334",
          fillRule: "evenodd",
          d: "m18.8 15.559-.287.17.082-.345-.274-.254h.358l.12-.326.14.326h.306l-.24.253.115.345-.32-.17Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FFD100",
          d: "m18.8 15.559.256-.487-.272-.144-.265.157.28.474Zm-.287.17-.535-.128-.299 1.26 1.115-.66-.28-.473Zm.082-.345.535.126.074-.312-.236-.219-.373.405Zm-.274-.254v-.55h-1.406l1.033.954.373-.404Zm.358 0v.55h.384l.132-.36-.516-.19Zm.12-.326.505-.218-.546-1.264-.475 1.292.516.19Zm.14.326-.504.218.143.332h.362v-.55Zm.306 0 .4.378.878-.928h-1.278v.55Zm-.24.253-.4-.378-.226.24.105.313.521-.175Zm.115.345-.256.487 1.214.64-.436-1.301-.522.174Zm-.601-.643-.286.17.56.946.287-.17-.561-.946Zm.53.77.081-.345-1.07-.253-.082.344 1.07.254Zm-.08-.876-.275-.253-.746.808.274.253.746-.808Zm-.648.701h.358v-1.1h-.358v1.1Zm.874-.36.12-.326-1.032-.38-.12.326 1.032.38Zm-.901-.298.14.326 1.01-.436-.14-.326-1.01.436Zm.646.658h.305v-1.1h-.305v1.1Zm-.095-.928-.24.253.8.757.24-.254-.8-.756Zm-.361.806.115.345 1.043-.35-.115-.344-1.043.349Zm.893-.316-.32-.17-.514.973.32.17.514-.973Z",
          mask: "url(#g)"
        })]
      })]
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFD100",
      d: "M15.527 17.307c.052.147.422.341.853.092.293-.175.483-.424.664-.867.051-.11.077-.249-.043-.332-.095-.074-.25-.157-.32-.23-.034-.037-.068-.065-.094-.093a.39.39 0 0 1 .052.065c.172.221-.009.544-.199.738-.138.138-.387.48-.75.156-.077-.073-.258.231-.163.47ZM20.767 17.307c-.06.147-.43.341-.853.092-.293-.175-.483-.424-.673-.867-.043-.11-.068-.249.052-.332.095-.074.25-.157.32-.23a.884.884 0 0 1 .094-.093.4.4 0 0 0-.052.065c-.172.221.009.544.19.738.138.138.396.48.758.156.078-.073.25.231.164.47Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFD100",
      d: "M18.147 18.1c.69 0 1.75-.332 2.318-1.494.095-.194 0-.295-.112-.36a1.321 1.321 0 0 1-.344-.267c.137.147.112.249.017.415-.44.784-1.043 1.18-1.88 1.18-.835 0-1.438-.396-1.878-1.18-.095-.166-.12-.268.009-.415a1.193 1.193 0 0 1-.345.267c-.112.065-.207.166-.112.36a2.597 2.597 0 0 0 2.327 1.494Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F50100",
      d: "M16.552 16.541c-.017-.092-.129-.055-.163.056-.043-.065-.087-.13-.121-.203-.104-.166-.12-.277.026-.434.069-.074.207-.157.302-.064.198.175.094.46-.044.645ZM19.733 16.541c.017-.092.138-.055.172.056.043-.065.086-.13.12-.203.104-.166.122-.277-.034-.434-.06-.074-.198-.157-.301-.064-.19.175-.095.46.043.645Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFD100",
      fillRule: "evenodd",
      d: "M18.915 10.755c0-.027 0-.055-.002-.082.264-.506.69-.842.921-1.025.099-.077.162-.127.162-.15 0-.07-.585.133-1.144.645.125-.376.462-.724.64-.908.071-.073.117-.12.113-.132-.013-.037-.517.292-.917.775a.656.656 0 0 0-.161-.171l.268-.447h-.9l.251.42a.51.51 0 0 0-.117.09c-.382-.423-.813-.701-.824-.667-.004.012.042.059.113.132.15.156.415.429.568.737a1.2 1.2 0 0 0-.036.076c-.524-.441-1.036-.615-1.036-.55 0 .023.063.073.161.15.19.15.512.404.767.771-.009.055-.016.111-.02.169-.195-.163-.36-.225-.36-.195 0 .012.03.04.074.082.07.066.178.168.278.31.007.61.273 1.102.6 1.102.263 0 .486-.316.568-.757.017.008.03.009.035-.004.114-.328.34-.54.456-.65.045-.043.074-.07.074-.083 0-.039-.274.075-.532.362Zm-.063-.612a1.201 1.201 0 0 0-.018.052l-.009-.028.027-.024Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#059334",
      d: "M17.068 11.41c-.072-.124-.268-.179-.35-.069-.032.027-.073.027-.104.041-.052 0-.117.035-.097.172.056 0 .056.034.087.034.02-.014.074.237.177.224.114 0 .215.063.236.09.03.042.072.152.02.206a.34.34 0 0 0 0 .425c.134.137.475.343.857-.055.371-.383.95-.164.99-.027.052.137.073.219.083.287.01.055.29.138.33.179.052.04.124.027.104-.096-.042-.384-.217-.439-.238-.617.103.014.176.014.217-.04.03-.056.072-.152.113-.179.031-.027.031-.055-.01-.041-.052.014-.082.041-.175.027-.22-.031-.166-1.07-.892-1.273-.45-.125-1.01.732-1.163.817a.066.066 0 0 1-.01.004c-.072 0-.134-.041-.175-.11Z"
    }), /*#__PURE__*/_jsx("mask", {
      id: "h",
      width: "14",
      height: "11",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 3h13.5v10.5H0z"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#h)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        d: "m-1.503 12.75 2.97 1.303 12.1-9.636 1.567-1.937-3.176-.435-4.936 4.152L3.05 8.995l-4.553 3.755Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F50100",
        d: "m-1.096 13.663 1.513.756L14.572 2.3h-2.125L-1.096 13.663Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        d: "m15.003 12.75-2.97 1.303-12.1-9.636-1.567-1.937 3.176-.435 4.936 4.152 3.972 2.798 4.553 3.755Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F50100",
        d: "m14.902 13.405-1.514.756-6.027-5.188-1.787-.58-7.36-5.906H.34l7.355 5.766 1.954.695 5.253 4.457Z"
      }), /*#__PURE__*/_jsxs("mask", {
        id: "i",
        width: "16",
        height: "13",
        x: "-1",
        y: "2",
        fill: "#000",
        maskUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M-1 2h16v13H-1z"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
          clipRule: "evenodd"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F50100",
        fillRule: "evenodd",
        d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        d: "M5.988 3v-.75h-.75V3h.75Zm1.5 0h.75v-.75h-.75V3Zm-1.5 4.5v.75h.75V7.5h-.75ZM0 7.5v-.75h-.75v.75H0ZM0 9h-.75v.75H0V9Zm5.988 0h.75v-.75h-.75V9Zm0 4.5h-.75v.75h.75v-.75Zm1.5 0v.75h.75v-.75h-.75Zm0-4.5v-.75h-.75V9h.75ZM13.5 9v.75h.75V9h-.75Zm0-1.5h.75v-.75h-.75v.75Zm-6.012 0h-.75v.75h.75V7.5Zm-1.5-3.75h1.5v-1.5h-1.5v1.5Zm.75 3.75V3h-1.5v4.5h1.5ZM0 8.25h5.988v-1.5H0v1.5ZM.75 9V7.5h-1.5V9h1.5Zm5.238-.75H0v1.5h5.988v-1.5Zm.75 5.25V9h-1.5v4.5h1.5Zm.75-.75h-1.5v1.5h1.5v-1.5ZM6.738 9v4.5h1.5V9h-1.5Zm6.762-.75H7.488v1.5H13.5v-1.5Zm-.75-.75V9h1.5V7.5h-1.5Zm-5.262.75H13.5v-1.5H7.488v1.5ZM6.738 3v4.5h1.5V3h-1.5Z",
        mask: "url(#i)"
      })]
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "b",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 3h24v18H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "c",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M16.383 12.766h4.503v4.503h-4.503z"
      })
    })]
  })]
}));
//# sourceMappingURL=CaymanIslands.js.map